import axios from "axios";
import store from "@/store";

const apiConfig = {
  baseURL: "https://api.riskma.jp/v1",
  retry: 1,
  region: "ap-northeast-1"
};

export const getToken = async () => {
  try {
    const res = await axios
      .create({
        responseType: "json",
        baseURL: apiConfig.baseURL
      })
      .post("/auth");
    const token = res.data.access_token;
    store.commit("SET_API_TOKEN", token);
    return token;
  } catch (e) {
    console.error(e);
    return null;
  }
};

const getWithToken = async (url, params) => {
  let token = store.getters.apiToken;
  if (!token) {
    console.log(url, "get token");
    token = await getToken();
    if (!token) {
      console.error("Failed to get token");
      return null;
    }
  }
  return await axios
    .create({
      responseType: "json",
      headers: {
        "X-Auth-Token": `Bearer ${token}`
      },
      baseURL: apiConfig.baseURL
    })
    .get(url, {
      params
    });
};

export const get = async (url, params) => {
  for (let i = 0; i <= apiConfig.retry; i++) {
    try {
      const response = await getWithToken(url, params);
      return response.data;
    } catch (error) {
      if (error.response.status === 401) {
        store.commit("SET_API_TOKEN", "");
      } else {
        return null;
      }
    }
  }
  return null;
};
